import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import alertService from '../services/alertService';
import { authService } from '../services/authService';

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [loading, setLoading] = useState(false);

  const validateEmail = (value: string) => {
    return /[^\s@]+@[^\s@]+\.[^\s@]+/.test(value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !validateEmail(email.trim())) {
      alertService.toast('warning', 'Informe um email válido');
      return;
    }
    setLoading(true);
    try {
      const res = await authService.requestPasswordReset(email.trim(), tenantId.trim() || undefined);
      if (res.success) {
        alertService.toast('success', res.message || 'Se existir uma conta com este email, enviamos instruções.');
        navigate('/login');
      } else {
        alertService.toast('error', res.error || 'Não foi possível iniciar a recuperação de senha.');
      }
    } catch (err: any) {
      alertService.toast('error', err?.message || 'Erro ao enviar solicitação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white shadow-sm border rounded-lg p-6">
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Recuperar Senha</h1>
        <p className="text-sm text-gray-600 mb-6">
          Informe seu email para receber instruções de redefinição de senha.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
            <input
              id="email"
              type="email"
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 border-gray-300"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu.email@exemplo.com"
              autoComplete="email"
              required
            />
          </div>

          <div>
            <label htmlFor="tenantId" className="block text-sm font-medium text-gray-700 mb-1">Tenant ID (opcional)</label>
            <input
              id="tenantId"
              type="text"
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 border-gray-300"
              value={tenantId}
              onChange={(e) => setTenantId(e.target.value)}
              placeholder="Informe caso sua empresa utilize multi-tenant"
            />
          </div>

          <button
            type="submit"
            className={`w-full py-2.5 rounded-lg text-white font-medium bg-red-600 hover:bg-red-700 transition ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
            disabled={loading}
            title="Enviar instruções de recuperação"
          >
            {loading ? 'Enviando...' : 'Enviar instruções'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-red-600 hover:text-red-700">Voltar ao login</Link>
        </div>

        <div className="mt-6 bg-gray-50 border rounded p-3">
          <p className="text-xs text-gray-600">
            Observação: Conforme a documentação atual, o fluxo de recuperação de senha pode não estar disponível. Caso o endpoint não exista, exibiremos uma mensagem informativa.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;